/*
 * Valenor — Status row rotation.
 * Walks every [data-vln-status-rotation] element, reads the JSON payload
 * from its [data-vln-status-messages] <script>, and every 3 s fades the
 * icon + text to the next message while flipping the indicator dots.
 * Respects prefers-reduced-motion (no rotation).
 */
(() => {
  if (typeof window === 'undefined' || window.__vlnStatusInit) return;
  window.__vlnStatusInit = true;

  const ROTATION_MS = 3000;
  const FADE_MS = 300;
  const reduceMotion =
    window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  const renderIcon = (name) => {
    // Keep the SVG bank in sync with snippets/vln-icon.liquid.
    const SVG = {
      truck:
        '<svg viewBox="0 0 24 24" width="18" height="18" fill="none" stroke="currentColor" stroke-width="1.25" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><rect x="1.5" y="6.5" width="12" height="9"></rect><path d="M13.5 9h4.5L22 12.5v3H13.5z"></path><circle cx="5" cy="17" r="1.5"></circle><circle cx="18" cy="17" r="1.5"></circle></svg>',
      return:
        '<svg viewBox="0 0 24 24" width="18" height="18" fill="none" stroke="currentColor" stroke-width="1.25" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M3 12a9 9 0 1 0 3-6.7"></path><polyline points="3,4 3,9 8,9"></polyline></svg>',
      shield:
        '<svg viewBox="0 0 24 24" width="18" height="18" fill="none" stroke="currentColor" stroke-width="1.25" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M12 2 4 5v7c0 5 3.5 8.5 8 10 4.5-1.5 8-5 8-10V5z"></path></svg>',
      check:
        '<svg viewBox="0 0 24 24" width="18" height="18" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><circle cx="12" cy="12" r="9.5"></circle><polyline points="8,12.5 11,15.5 16,9.5"></polyline></svg>',
      box:
        '<svg viewBox="0 0 24 24" width="18" height="18" fill="none" stroke="currentColor" stroke-width="1.25" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M3 8l9-4 9 4v8l-9 4-9-4z"></path><path d="M3 8l9 4 9-4"></path><path d="M12 12v8"></path></svg>',
      gift:
        '<svg viewBox="0 0 24 24" width="18" height="18" fill="none" stroke="currentColor" stroke-width="1.25" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><rect x="3" y="9" width="18" height="12" rx="1"></rect><path d="M3 13h18"></path><path d="M12 9v12"></path><path d="M8 9c-1.5 0-3-1-3-2.5S6 4 7.5 4C10 4 12 9 12 9s2-5 4.5-5C18 4 19 5 19 6.5S17.5 9 16 9"></path></svg>',
    };
    if (SVG[name]) return SVG[name];
    // Plain text / emoji fallback.
    return name || '';
  };

  const initOne = (wrap) => {
    const script = wrap.querySelector('[data-vln-status-messages]');
    if (!script) return;
    let payload;
    try {
      payload = JSON.parse(script.textContent);
    } catch (_) {
      return;
    }
    const messages = Array.isArray(payload && payload.messages) ? payload.messages : [];
    if (messages.length < 2) return;

    const textEl = wrap.querySelector('[data-vln-status-slot="text"]');
    const iconEl = wrap.querySelector('[data-vln-status-slot="icon"]');
    const dots = wrap.querySelectorAll('.vln-status-row__indicator-dot');

    let idx = 0;
    const tick = () => {
      if (textEl) textEl.style.opacity = '0';
      if (iconEl) iconEl.style.opacity = '0';

      setTimeout(() => {
        idx = (idx + 1) % messages.length;
        const m = messages[idx];
        if (textEl) textEl.textContent = m.text || '';
        if (iconEl) iconEl.innerHTML = renderIcon(m.icon);
        dots.forEach((d, i) =>
          d.classList.toggle('vln-status-row__indicator-dot--active', i === idx)
        );
        if (textEl) textEl.style.opacity = '1';
        if (iconEl) iconEl.style.opacity = '1';
      }, FADE_MS);
    };

    setInterval(tick, ROTATION_MS);
  };

  /* Legacy product-status random low-stock logic — ported 1:1.
     Persists the first dice-roll per product in localStorage so returning
     sessions see the same message. */
  const applyLowStock = (row) => {
    if (row.dataset.vlnStatusShowLowStock !== 'true') return;
    const handle = row.dataset.vlnStatusProductHandle || '';
    if (!handle) return;
    const chance = parseInt(row.dataset.vlnStatusLowChance || '40', 10);
    const template = row.dataset.vlnStatusLowTemplate || 'Plus que {count} en stock';
    const key = 'vln_lowstock_' + handle;

    let data;
    try {
      const stored = localStorage.getItem(key);
      if (stored) data = JSON.parse(stored);
    } catch (_) {}

    if (!data) {
      data = {
        isLow: Math.random() * 100 < chance,
        // qty ∈ [3, 10] — below 3 reads as suspiciously low, above 10
        // defeats the "almost out" psychology.
        qty: Math.floor(Math.random() * 8) + 3,
      };
      try {
        localStorage.setItem(key, JSON.stringify(data));
      } catch (_) {}
    }

    if (!data.isLow) return;
    const stock = row.querySelector('[data-vln-status-stock]');
    const text = row.querySelector('[data-vln-status-stock-text]');
    if (!stock || !text) return;
    stock.classList.remove('vln-status-row__stock--ok');
    stock.classList.add('vln-status-row__stock--warn');
    text.textContent = template.replace('{count}', data.qty);
  };

  const init = () => {
    document.querySelectorAll('.vln-status-row').forEach(applyLowStock);
    if (reduceMotion) return;
    document.querySelectorAll('[data-vln-status-rotation]').forEach(initOne);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }
})();
